import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { toast } from "react-toastify";
import Avatar from 'react-avatar-edit';
import {Button} from "reactstrap";

class AcatarEditor extends React.Component {

  constructor(props) {
    super(props)
    const src = "";
    this.state = {
      preview: null,
      src
    }
    this.onCrop = this.onCrop.bind(this)
    this.onClose = this.onClose.bind(this)
    this.onBeforeFileLoad = this.onBeforeFileLoad.bind(this)
  }

  onClose() {
    this.setState({ preview: null })
  }

  onCrop(preview) {
    this.setState({ preview })
  }

  onBeforeFileLoad(elem) {
    if (elem.target.files[0].size > 8000000) {
      toast.error("File is too big! File should be less than 800kb");
      elem.target.value = "";
    };
  }

  saveImage = () => {
    this.props.onSave(this.state.preview)
    this.props.toggleSliderVisibility()
  }


  render() {
    return (
      <div className="animation-slider-sidebar" style={{ width: this.props.width ? this.props.width : "40vw" }}>
        <div className="sidebar_header">
          <span className="heading">Change Avatar</span>
          <div>
            <Button
              className="btn ml-1"
              color="primary"
              disabled = {this.state.preview ? false: true }
              onClick={this.saveImage}
            >
              Save
            </Button>
            <Button
              className="btn ml-1"
              outline
              color="danger"
              onClick={this.props.toggleSliderVisibility}
            >
              Cancel
            </Button>
          </div>
        </div>
        <div className="p-2 flex-column d-flex justify-content-center align-items-center">
          <div className="text-center">
            <Avatar
            label="Click to choose your avatar"
            labelStyle={{fontSize: "14px", FontWeight: "500", alignItems: "center", color: "#cacaca"}}
            borderStyle = {{border: "1px dashed #cacaca"}}
            width={390}
            height={295}
            onCrop={this.onCrop}
            onClose={this.onClose}
            onBeforeFileLoad={this.onBeforeFileLoad}
            src={this.state.src}
          />
          </div>
          <span className="text-muted"><i>(Max File Size: 800kb )</i></span>
        </div>  
          {
            this.state.preview
            ? <div className="d-flex flex-column justify-content-around align-items-center mt-3" style={{ minHeight: "200px" }}>
                <img src={this.state.preview} alt="avatar" />
                <h6 className="text-muted mt-2">Image Preview</h6>
              </div>
            : null  
          }
        
      </div>  
    )
  }
}

export default AcatarEditor;